var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSorter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 27,
    viewBox: "0 0 12 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96854 15.9375H2.03146C1.7934 15.9375 1.66047 16.1889 1.8079 16.3605L5.77644 20.9622C5.89003 21.0939 6.10876 21.0939 6.22356 20.9622L10.1921 16.3605C10.3395 16.1889 10.2066 15.9375 9.96854 15.9375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1921 12.6381L6.22356 8.03629C6.10997 7.90457 5.89124 7.90457 5.77644 8.03629L1.8079 12.6381C1.66047 12.8097 1.7934 13.061 2.03146 13.061H9.96854C10.2066 13.061 10.3395 12.8097 10.1921 12.6381Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorter);
export default __webpack_public_path__ + "static/media/sorter.259e5b63591fbf40b59ad1780e5a6f89.svg";
export { ForwardRef as ReactComponent };